import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEmailType implements BaseEnumType {
  private static allValues: EnumEmailType[] = []; // make sure this is top-most
  
  public static mSOutlook = new EnumEmailType(0, "MSOutlook", "enum_email_type_m_s_outlook");
  public static sMTP = new EnumEmailType(1, "SMTP", "enum_email_type_s_m_t_p");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEmailType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isMSOutlook() { return this === EnumEmailType.mSOutlook; }
  public isSMTP() { return this === EnumEmailType.sMTP; }

  public static getValues(): readonly EnumEmailType[] {
    return EnumEmailType.allValues;
  }

  public static getValuesExcept0(): readonly EnumEmailType[] {
    return EnumEmailType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEmailType {
    const found = EnumEmailType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEmailType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEmailType): EnumEmailType {
    const found = name ? EnumEmailType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEmailType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEmailType>): boolean {
    return this.key === other?.key;
  }
}